import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'

import { ChakraProvider } from '@chakra-ui/react'

import Header from './pages/page_elements/Header'
import Footer from './pages/page_elements/Footer'

import Login from './pages/Login'
import Register from './pages/Register'
import MyJourneys from './pages/MyJourneys'
import Insights from './pages/Insights'
import Creator from './pages/Creator'
import CreatorEdit from './pages/creator/CreatorEdit'
import CreatorExport from './pages/creator/CreatorExport'
import Preferences from './pages/Preferences'
import ContentContainer from './pages/page_elements/ContentContainer'
import Profile from './pages/Profile'
import PublicProfileSlug from './pages/profile/PublicProfileSlug'

function App() {
  return (
    <ChakraProvider>
      <Router>
        <ContentContainer>
        <Header />

        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />

          <Route path='/myjourneys' element={<MyJourneys />} />
          <Route path='/myjourneys/insights' element={<Insights />} />

          <Route path='/creator' element={<Creator />} />
          <Route path='/creator/edit' element={<CreatorEdit />} />
          <Route path='/creator/export' element={<CreatorExport />} />

          <Route path='/preferences' element={<Preferences />} />

          <Route path='/profile' element={<Profile />} />
          <Route path='/profile/:displayName' element={<PublicProfileSlug />} />

        </Routes>
        </ContentContainer>

        <Footer />
      </Router>
    </ChakraProvider>
  );
}

export default App;
